import { PluginType } from '@deephaven/plugin';
import { dhPandas } from '@deephaven/icons';
import { PandasWidgetPlugin } from "./PandasWidgetPlugin.js";
import { PandasPanelPlugin } from "./PandasPanelPlugin.js";
var PandasPluginConfig = {
  name: 'PandasPanel',
  title: 'Pandas',
  type: PluginType.WIDGET_PLUGIN,
  component: PandasWidgetPlugin,
  panelComponent: PandasPanelPlugin,
  supportedTypes: 'pandas.DataFrame',
  icon: dhPandas
};
export default PandasPluginConfig;
//# sourceMappingURL=PandasPluginConfig.js.map